import { createReducer } from '@reduxjs/toolkit';

import * as controlActionTypes from './controls.actions';
import { ControlState } from './models';

const INITIAL_STATE: ControlState = {
  controls: null,
  loading: false,
  loaded: false,
  errMsg: null
};

// Use createReducer helper functions since they are stictly typed out of the box

const controlsReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(controlActionTypes.loadControlsStart, (state) => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    })
    .addCase(controlActionTypes.loadControlsSuccess, (state, action) => {
      return {
        ...state,
        controls: action.payload,
        loading: false,
        loaded: true
      };
    })
    .addCase(controlActionTypes.loadControlsFailure, (state, action) => {
      return {
        ...state,
        loading: false,
        loaded: false,
        errMsg: action.payload

      };
    });
});

export default controlsReducer;